export default __webpack_public_path__ + "static/media/icon-angle-up.82bbba67.svg";